<template>
  <a-card :bordered="false">
    <div>
      <a-form :form="form" >
        <a-row>
          <a-col :span="12">
            <a-form-item label="规则名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                allow-clear
                v-decorator="[
                  'name',
                  {
                    rules: [
                      { required: true, message: '请输入' },
                    ],
                  },
                ]"
                placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="合同类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                allow-clear
                v-decorator="[
                  'type',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请选择"
                option-filter-prop="children"
              >
                <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_sell_contract_type">
                  {{ val }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="延期天数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number
                style="width: 30%"
                :min="1"
                v-decorator="[
                  'postpone_days',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ]
                  }
                ]"
                placeholder="请输入天数"/>
              <a-select
                v-decorator="[
                  'postpone_days_type',
                  {
                    rules: [
                      { required: true, message: '请选择' }
                    ]
                  }
                ]"
                default-value="1"
                style="width: 20%"
                placeholder="选择">
                <a-select-option value="1">
                  天
                </a-select-option>
                <a-select-option value="2">
                  工作日
                </a-select-option>
              </a-select>
              <span>(合同创建后延期提醒)</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="提醒模板" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                @search="this.templateSearch"
                show-search
                allow-clear
                v-decorator="[
                  'template_id',
                  {
                    rules: [
                      { required: true, message: '请选择' },
                    ],
                  },
                ]"
                placeholder="请选择"
                option-filter-prop="children"
              >
                <a-spin v-if="templateFetching" slot="notFoundContent" size="small" />
                <a-select-option v-for="d in templateList" :key="d.id">
                  {{ d.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="开启规则" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-switch v-decorator="['is_enabled', { valuePropName: 'checked' }]" checked-children="是" un-checked-children="否"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-form-item v-bind="buttonCol">
          <a-row>
            <a-col span="6" :offset="6">
              <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
            </a-col>
            <a-col span="10">
              <a-button @click="handleGoBack">返回</a-button>
            </a-col>
            <a-col span="8"></a-col>
          </a-row>
        </a-form-item>
      </a-form>
    </div>
  </a-card>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import {
  trade_custom_reminder_rule_list,
  trade_custom_reminder_rule_update,
  trade_custom_reminder_template_list
} from '@/api/trade_custom_reminder'
import debounce from 'lodash/debounce'

const fields = ['name', 'type', 'postpone_days', 'postpone_days_type', 'is_enabled', 'template_id']

export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.templateSearch = debounce(this.handleTemplateSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      templateFetching: false,
      templateList: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadRuleData()
    })
  },
  methods: {
    moment,
    handleGoBack () {
      this.$router.go(-1)
    },
    loadRuleData () {
      trade_custom_reminder_rule_list({ id: this.$route.params.id })
        .then(res => {
          const list = res.data.entries
          if (list && list.length > 0) {
            const data = list[0]
            data.type = data.type + ''
            data.postpone_days_type = data.postpone_days_type + ''
            this.loadEditInfo(data)
            if (data.template_id > 0) {
              this.loadTemplateList({ id: data.template_id })
            }
          }
        })
    },
    handleTemplateSearch (value) {
      this.loadTemplateList({ name: value })
    },
    loadTemplateList (parameter) {
      this.templateFetching = true
      trade_custom_reminder_template_list(parameter).then((res) => {
        const result = res.data.entries || []
        this.templateList = result
      }).finally(() => {
        this.templateFetching = false
      })
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values)
        if (!err) {
          values['is_enabled'] = values['is_enabled'] === true ? 1 : 0
          trade_custom_reminder_rule_update(values, this.$route.params.id).then((res) => {
            if (res.code === 1000) {
              this.handleGoBack()
              console.log(res, '修改成功')
            }
            })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, fields)
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
